import React from 'react'
import Image from '../../images/logo/logo.svg'

const Logo = () => {
  return (
    <img src={Image} alt="Memory Game Logo"/>
  )
}

export default Logo